import { render, staticRenderFns } from "./user_tv_placard_media.vue?vue&type=template&id=33c7d95a&scoped=true"
import script from "./user_tv_placard_media.vue?vue&type=script&lang=js"
export * from "./user_tv_placard_media.vue?vue&type=script&lang=js"
import style0 from "./user_tv_placard_media.vue?vue&type=style&index=0&id=33c7d95a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c7d95a",
  null
  
)

export default component.exports